import { Controller } from '@hotwired/stimulus';
import { importPublicKey, hybridEncryptOrgKey } from '../vault_crypto';

export default class extends Controller {
  static targets = ['recoveryCode', 'encryptedOrgKey'];
  static values = { cryptoOptions: Object, userPublicKey: String, t: Object };

  async bootstrap(event) {
    event.preventDefault();

    const recoveryCode = this.recoveryCodeTarget.value;
    if (!recoveryCode) {
      alert(this.tValue.recovery_code_required);
      return;
    }

    try {
      // 1. Unwrap the org private key using the recovery code
      const opts = this.cryptoOptionsValue;
      const decryptor = new Decrypt({
        wrapped_key: opts.wrapped_key,
        salt: opts.salt,
        iv: opts.iv,
        enc_shared_keys: [],
      });
      await decryptor.setPasswordUnwrapKey(recoveryCode);
      const orgPrivBytes = await crypto.subtle.exportKey('pkcs8', decryptor.privateKey);

      // 2. Hybrid-encrypt org private key to the user's existing public key
      const userPublicKey = await importPublicKey(this.userPublicKeyValue);
      this.encryptedOrgKeyTarget.value = `0:${await hybridEncryptOrgKey(orgPrivBytes, userPublicKey)}`;

      this.recoveryCodeTarget.disabled = true;
      this.element.submit();
    } catch (e) {
      console.error('Bootstrap org key failed:', e);
      alert(this.tValue.invalid_recovery_code);
    }
  }
}
